import React from 'react';
import './Badge.css';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'neutral' | 'success' | 'warning' | 'danger' | 'accent';
  size?: 'sm' | 'md';
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'neutral',
  size = 'md',
  children,
  className = '',
  ...props
}) => {
  return (
    <span
      className={`sedlex-badge sedlex-badge--${variant} sedlex-badge--${size} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export interface ConfidenceBadgeProps {
  confidence: number | null | undefined;
  resolutionState?: string | null;
}

export const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({
  confidence,
  resolutionState,
}) => {
  if (confidence === null || confidence === undefined) {
    return <Badge variant="neutral">Unrated</Badge>;
  }

  let label = `${Math.round(confidence * 100)}%`;
  let variant: BadgeProps['variant'];

  if (resolutionState === 'AMBIGUOUS' || resolutionState === 'UNRESOLVED') {
    variant = 'warning';
    label += ` (${resolutionState})`;
  } else if (confidence >= 0.9) {
    variant = 'success';
  } else if (confidence >= 0.7) {
    variant = 'accent';
  } else {
    variant = 'warning';
  }

  return (
    <Badge
      variant={variant}
      title={`Confidence: ${confidence} | Resolution: ${resolutionState || 'RESOLVED'}`}
    >
      {label}
    </Badge>
  );
};
